// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3jaSb","clinicsSelect":"TableHeading_clinicsSelect__121GO"};